'use client'

import Link from 'next/link'
import { useSelectedLayoutSegments } from 'next/navigation'
import { useTranslations } from 'next-intl'
import { clsx } from 'clsx'
import { useFeatureFlags } from '@node-space/hooks'
import { Box as Group, Box as Wrapper } from '@node-space/storybook-components/dist/Box'
import Text from '@node-space/storybook-components/dist/Text'
import HowToIcon from '../component-library/Icons/HowToIcon'
import { SecurePaymentsByIcon } from '../component-library/Icons/SecurePaymentsByIcon'
import { BVNK } from '@/utils/constants'


export const LayoutFooter = () => {
  const segments = useSelectedLayoutSegments()
  const t = useTranslations()
  const { enablePoweredByFooter } = useFeatureFlags()
  const showHowToPay = segments?.includes('pay') || segments?.includes('channel')


  return (
    <Wrapper
      paddingT={16}
      paddingX={8}
      flex
      className={clsx('pb-6 sm:pb-0', showHowToPay ? 'justify-between' : 'justify-end')}
    >
      {showHowToPay && BVNK && (
        <Group flex alignItems="center">
          <Link className="flex" href={process.env.NEXT_PUBLIC_HOW_TO_PAY || ''} target="_blank">
            <HowToIcon />
            <Text size="xs" color="secondary-500" className="pl-1">
              {t('howToPay')}
            </Text>
          </Link>
        </Group>
      )}
      {enablePoweredByFooter && <SecurePaymentsByIcon />}
    </Wrapper>
  )
}